import { Component, ViewChild, Injectable, OnInit, OnDestroy, OnChanges, AfterViewInit, AfterContentChecked, AfterContentInit, AfterViewChecked, DoCheck } from '@angular/core';
import { ModalController, LoadingController, Platform, IonInfiniteScroll, IonicModule } from '@ionic/angular';
import { BeerServiceProvider } from "../../providers/beer-service/beer-service";
import { RequestUser, /*BeerProfileRequest,*/ SearchRequest, SearchCharacteristic, SearchCharacteristicWithType, SearchType, AnalysisItem, Venue } from "../../models/models";
import { LocationServiceProvider } from "../../providers/location-service/location-service";
import { UserDataProvider } from "../../providers/user-data/user-data";
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { RefdataProvider } from '../../providers/refdata/refdata';
import { BeerHiveComponent } from '../../components/beer-hive/beer-hive';
import { SearchProvider } from '../../providers/search/search';

import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage-angular';
import { AnalysisServiceProvider } from '../../providers/analysis-service/analysis-service';
import { AppEventService } from '../../app/app-events';
import { Router } from '@angular/router';
import { NavBarComponent } from '../../components/nav-bar/nav-bar';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AddBeerFormPage_PATH } from '../../app/app-constants';
import { firstValueFrom } from 'rxjs';

/**
 * Generated class for the SearchPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-search',
  templateUrl: 'search.html',
  styleUrls: ['./search.scss'],
  standalone: false,
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    TranslateModule,
//    NavBarComponent
  ],
  animations: [
    trigger('collapse', [
      state('invisible', style({
        height: '0px'
      })),
      state('visible', style({
        height: '*'
      })),
      transition('invisible <=> visible', animate('100ms'))
    ])
  ]
})
@Injectable({
    providedIn: 'root'
})
export class SearchPage implements OnInit, OnDestroy, OnChanges, DoCheck,
                                   AfterViewInit, AfterContentChecked, AfterContentInit, AfterViewChecked {
  public static PATH: string = 'search';
  private foundBeers: Array<any> = [];
  public searchCount: number;

  private searchRequest: SearchRequest = null;
  private rowCount: number = 20;
  private pageNumber: number = 0;
  private fetchMore: boolean = true;

  private collapseStateColour: string;
  private collapseStateTaste: string;
  private collapseStateCharacteristics: string;
  public collapseStateWhitespace: string;
  private allSearchCharacteristics: Array<SearchCharacteristicWithType> = [];
  public showInfoText: string = 'noSelection';
  public timestamp;

  private sortFilter: any = { sortField: "name", direction: "ASC" };

  sortfilterChangedSubscription: any;
  venueSelectedSubscription: any;
  venueDeselectedSubscription: any;

  @ViewChild('beerhive') beerhiveComp: BeerHiveComponent;

  private selectedVenue: Venue = null;

  isLoading: Array<any> = [];
  loading: Promise<HTMLIonLoadingElement> = null;

  public showResults: boolean = false;

  private backButtonPressed: boolean = false;

  private searchTextInputSubs: any;
  private searchBeerhiveInputSubs: any;
  private searchColourInputSubs: any;
  private searchTextCancelSubs: any;
  private clearFoundBeersSubs: any;
  private removeAllSearchSubs: any;
  private searchAddBeerSubscription: any;
  private backButtonSubscription: any;
  private searchButtonSubscription: any;

  constructor(
    public router: Router,
    private viewCtrl: ModalController,
    private beerService: BeerServiceProvider,
    private events: AppEventService,
    private locationService: LocationServiceProvider,
    private userData: UserDataProvider,
    private refdata: RefdataProvider,
    //private bhutil: BhutilProvider,
    private loadingCtrl: LoadingController,
    private translateService: TranslateService,
    private searchProvider: SearchProvider,
    private storage: Storage,
    private platform: Platform,
    private analysisService: AnalysisServiceProvider
  ) {

    this.log("Hello SearchPage");

    this.events.publish("set:shouldupdate", true);

    this.collapseStateColour = "invisible";
    this.collapseStateTaste = "invisible";
    this.collapseStateCharacteristics = "invisible";
    this.collapseStateWhitespace = "visible";

    //debugger; // creating a new SearchPage component
    this.timestamp = Date.now();
    //debugger; // creating a new SearchPage component

    this.initFoundBeers();
    this.getSelectedVenue();
  }

  initFoundBeers() {
    this.foundBeers = new Array();
    this.pageNumber = 0;
    this.fetchMore = true;
    this.searchRequest = null;
  }

  getSelectedVenue() {
    this.userData.init().then(() => {
      this.storage.get('selected-venue').then((venue) => {
        // First read the selected venue from storage
        let venueJSON = JSON.parse(venue);
        if (venueJSON != null) {
          this.selectedVenue = venueJSON;
        }
        this.log("currently venue with id selected: " + (this.selectedVenue ? this.selectedVenue.id : null));
      });
    });
  }

  ngOnInit() {
    console.log('search - ngOnInit');

    this.initFoundBeers();
    this.getSelectedVenue();

    //debugger;
    // resetting the search characteristics to the previous search
    //setting last caller page
    let prevPage = this.analysisService.getLastPage();
    this.analysisService.setLastPage("search");
    if(prevPage === "analysis") {
      // we should reset the analysis!
      this.log("previous page with beer-hive component was analysis, we should clear the analysis!");
      //this.events.publish("clear:analysis", true);
    }
    this.allSearchCharacteristics = this.searchProvider.getSearchParams();

    let type2chars = [];
    let i = 0;
    let b = 0;
    let a = 0;
    let car = 0;
    let alc = 0;
    let itemIndex: any;
    for (itemIndex in this.allSearchCharacteristics) {
      let item = this.allSearchCharacteristics[itemIndex];
      let keyName = item.characteristic.key;
      let keyValue = item.characteristic.value.valueOf();
      //debugger;
      if (item.type == SearchType.SEARCH_HIVE) {
        if (keyName.indexOf("_") != -1) {
          type2chars.push(keyName);
        }
        else if (keyName === "intensity") {
          i = keyValue;
        }
        else if (keyName === "body") {
          b = keyValue;
        }
        else if (keyName === "astringent") {
          a = keyValue;
        }
        else if (keyName === "alcohol") {
          alc = keyValue;
        }
        else if (keyName === "carbonation") {
          car = keyValue;
        }
      }
    }
    //debugger;
    if (type2chars.length > 0) {
      //debugger;
      this.events.publish("set:characteristics", type2chars);// hier verder
      // dit moet vervangen worden door characteritstics voor items met _
      // en door mouthfeelevent voor items i;b;a;...
    }

    // mouthfeel event (i,b,a,carbonation,alcohol)
    let mouthfeelEvent = {};
    mouthfeelEvent["alcohol"] = alc;
    mouthfeelEvent["astringent"] = a;
    mouthfeelEvent["body"] = b;
    mouthfeelEvent["carbonation"] = car;
    mouthfeelEvent["intensity"] = i;
    mouthfeelEvent["source"] = 2;
    // only fire the event when there is meaningful information
    if (alc != 0 || car != 0 || i != 0 || b != 0 || a != 0) {
      //debugger;
      // add a small delay
      setTimeout(() => {
        this.events.publish("update:mouthfeel", mouthfeelEvent);
      }, 500);

    }

    this.searchTextInputSubs = (text) => {
      this.userData.getUserID().then((userID) => {
        this.log("(1 - user logged in:) " + userID);
        let user = new RequestUser(userID, this.locationService.latitude, this.locationService.longitude);
        this.searchRequest = new SearchRequest(user.userid, user.latitude, user.longitude, text, [], this.rowCount, this.pageNumber, this.sortFilter.sortField, this.sortFilter.direction, (this.selectedVenue ? this.selectedVenue.id : null));
        //shouldn't request be called here? next line seems to fix the call...
        this.fetchMore = true;

        this.loadNext(false, null);
      });
    };
    this.events.subscribe('search:textInput', this.searchTextInputSubs);

    this.clearFoundBeersSubs = (val) => {
      this.log(" SUB clear:foundbeers => show search screen again");
      this.initFoundBeers();
      this.searchCount = 0;
      this.showInfoText = 'noSelection';

      if (this.allSearchCharacteristics !== undefined && this.allSearchCharacteristics.length > 0) {

        setTimeout(function () {
          this.showSearchAgain();
        }.bind(this), 200);
      }
    };
    this.events.subscribe('clear:foundbeers', this.clearFoundBeersSubs);

    this.searchBeerhiveInputSubs = (beerhiveCharacteristics: Array<SearchCharacteristicWithType>) => {

      let oldItems = this.allSearchCharacteristics;
      //debugger;// volgende regel is mogelijk het issue!
      this.allSearchCharacteristics = [];

      // loop through all
      let itemIndex: any;
      for (itemIndex in oldItems) {
        //if type == SEARCH_HIVE, remove
        let item = oldItems[itemIndex];
        if (item.type != SearchType.SEARCH_HIVE) {
          //debugger; // adding 1
          this.allSearchCharacteristics.push(item);
          this.searchProvider.setSearchParams(this.allSearchCharacteristics);
          this.log("ADD 1 ADD" + item.characteristic.key);
        }
        else {
          this.log("not adding this item...");// why not?
          // TEMP re-enabled for BEERHIVE-14
          // ONLY ADD THE ITEM IF NOT YET PRESENT
          // let alreadyPresent = false;
          // let apItemIndex: any;
          // for (apItemIndex in this.allSearchCharacteristics) {
          //   let apItem = this.allSearchCharacteristics[apItemIndex];
          //   if (apItem.characteristic.key === (item.characteristic.key)) {
          //     alreadyPresent = true;
          //   }
          // }
          // if(! alreadyPresent) {
          //   this.log("ADD 9 ADD " + item.characteristic.key);
          //   this.allSearchCharacteristics.push(item);
          //   this.searchProvider.setSearchParams(this.allSearchCharacteristics);
          // }
          // else {
          //   // TODO double check that the item also has the same value!
          //   this.log("Item was already present: " + item.characteristic.key + " with value " + item.characteristic.value);
          // }
        }
      }

      // add all from beerhiveCharacteristics
      let addItemIndex: any;
      for (addItemIndex in beerhiveCharacteristics) {
        let addItem = beerhiveCharacteristics[addItemIndex];
        //debugger; // adding 2
        let alreadyPresent2 = false;
        let apItemIndex2: any;
        for (apItemIndex2 in this.allSearchCharacteristics) {
          let apItem2 = this.allSearchCharacteristics[apItemIndex2];
          if (apItem2.characteristic.key === (addItem.characteristic.key)) {
            alreadyPresent2 = true;
          }
        }
        if (!alreadyPresent2) {
          // debugger;
          this.allSearchCharacteristics.push(addItem);
          this.log("ADD 2 ADD" + addItem.characteristic.key);
          this.searchProvider.setSearchParams(this.allSearchCharacteristics);
        }
        else {
          // debugger;
          // TODO double check that the item also has the same value!
          this.log("Item was already present: " + addItem.characteristic.key + " with value " + addItem.characteristic.value);
        }
      }

      // perform the search count method
      this.log(" calling searchBeersCount() from beerhiveInput");
      this.searchBeersCount();

    };
    this.events.subscribe("search:beerhiveInput", this.searchBeerhiveInputSubs);


    this.searchColourInputSubs = (colourCharacteristic: SearchCharacteristicWithType) => {

      let oldItems = this.allSearchCharacteristics;
      this.allSearchCharacteristics = [];

      // loop through all
      let itemIndex: any;
      for (itemIndex in oldItems) {
        //if type == SEARCH_COLOUR, remove
        let item = oldItems[itemIndex];
        if (item.type != SearchType.SEARCH_COLOUR) {
          //debugger;
          // adding 3
          this.allSearchCharacteristics.push(item);
          this.log("ADD 3 ADD" + item.characteristic.key);
          this.searchProvider.setSearchParams(this.allSearchCharacteristics);
        }
      }

      //add the item
      //debugger;
      // adding 4
      this.allSearchCharacteristics.push(colourCharacteristic);
      this.log("ADD 4 ADD" + colourCharacteristic.characteristic.key);
      this.searchProvider.setSearchParams(this.allSearchCharacteristics);

      //perform the search count method
      this.log(" calling searchBeersCount() from colourInput");
      this.searchBeersCount();

    };
    this.events.subscribe("search:colourInput", this.searchColourInputSubs);

    this.searchTextCancelSubs = (text) => {
      this.initFoundBeers();
    };
    this.events.subscribe('search:textCancel', this.searchTextCancelSubs);

    this.removeAllSearchSubs = (value) => {
      //debugger;
      this.log("we should delete all items");
      this.deleteAll();

    };
    this.events.subscribe("remove:allsearch", this.removeAllSearchSubs);

    this.searchAddBeerSubscription = () => {
      this.log("we should open add-beer-form");
      let searchReq = this.searchRequest;
      let searchString: String;
      if (searchReq == null) {
        searchString = "";
      }
      else {
        searchString = searchReq.searchstring;
      }
    this.router.navigate([ AddBeerFormPage_PATH ], { state: { data: {
          'searchtext': searchString
      }}});
    };
    this.events.subscribe("search:addbeer", this.searchAddBeerSubscription);

    this.sortfilterChangedSubscription = (sortFilter: any) => {
      this.log("noticed filter changed to: " + sortFilter);
      this.sortFilter = sortFilter;
      if (this.searchRequest != null) {
        this.fetchMore = true;
        this.loadNext(false, null);
      }
    };
    this.events.subscribe("sortfilter:changed", this.sortfilterChangedSubscription);

    this.venueSelectedSubscription = (venue: Venue) => {
      this.log("noticed filter veneu changed to: " + venue.id);
      this.selectedVenue = venue;
      if (this.searchRequest != null) {
        this.fetchMore = true;
        this.loadNext(false, null);
      } else {
        this.showInfoText = "counting";
        this.searchBeersCount();
      }
    };
    this.events.subscribe("venue:selected", this.venueSelectedSubscription);

    this.venueDeselectedSubscription = () => {
      this.log("noticed filter veneu changed to: null");
      this.selectedVenue = null;
      if (this.searchRequest != null) {
        this.fetchMore = true;
        this.loadNext(false, null);
      } else {
        this.showInfoText = "counting";
        this.searchBeersCount();
      }
    };
    this.events.subscribe("venue:deselected", this.venueDeselectedSubscription);

    this.backButtonSubscription = () => {
      this.backButtonPressed = true;
    };
    this.platform.backButton.subscribe(this.backButtonSubscription);

    this.searchButtonSubscription = () => {
      this.log("noticed searchButtonPressed!")
      this.events.publish("show:textsearchbar", true);
      this.showResults = false;
    };
    this.events.subscribe("navbar:searchpressed", this.searchButtonSubscription);
  }

  showSearchAgain() {
    let colour = -1;
    let sweet = -1;
    let sour = -1;
    let bitter = -1;
    let hoppy = -1;
    let fruity = -1;
    let malty = -1;

    let astringent = -1;
    let body = -1;
    let intensity = -1;
    let carbonation = -1;
    let alcohol = -1;

    let characteristics: AnalysisItem[] = [];
    let charValues: string[] = [];
    for (let theItem of this.allSearchCharacteristics) {
      let k = theItem.characteristic.key;
      let v = theItem.characteristic.value;
      this.log("Reload my: " + k + "/" + v);
      if (k === "colour")
        colour = v.valueOf();
      else if (k === "sweet")
        sweet = v.valueOf();
      else if (k === "sour")
        sour = v.valueOf();
      else if (k === "bitter")
        bitter = v.valueOf();
      else if (k === "hoppy")
        hoppy = v.valueOf();
      else if (k === "fruity")
        fruity = v.valueOf()
      else if (k === "malty")
        malty = v.valueOf()
      //else
      if (k === "astringent")
        astringent = v.valueOf();
      else if (k === "body")
        body = v.valueOf();
      else if (k === "intensity")
        intensity = v.valueOf();
      else if (k === "carbonation")
        carbonation = v.valueOf();
      else if (k === "alcohol")
        alcohol = v.valueOf();
      let pushItem = new AnalysisItem(k, v);
      let kindex = k.indexOf("_");
      if (kindex != -1 && v != 0) {
        characteristics.push(pushItem);
        charValues.push(pushItem.analysisKey.valueOf());
      }
      else {
        this.log("not adding this one! " + k + "/" + v);
      }
    }

    // update colour
    if (colour != -1) {
      this.events.publish("set:coloursearch", colour);
    }

    // update sldiers
    let sliderValues = {
      "sweet": sweet,
      "sour": sour,
      "bitter": bitter,
      "hoppy": hoppy,
      "fruity": fruity,
      "malty": malty,
      "update": false
    }
    this.events.publish("update:sliders", sliderValues);

    // update MF + aromas
    this.updateAromasFromAnalysisMy(charValues, alcohol, astringent, body, carbonation, intensity);

    // show items in list
    // debugger; //update 1
    this.updateSearchParams();

    // update count
    this.searchBeersCount();
  }

  ngOnChanges() {
    console.log('search - ngOnChanges');
  }

  ngDoCheck() {
    console.log('search - ngDoCheck');
  }

  ngAfterContentInit() {
    console.log('search - ngAfterContentInit');
  }

  ngAfterContentChecked() {
    console.log('search - ngAfterContentChecked');
  }

  ngAfterViewInit() {
    console.log('search - ngAfterViewInit');
  }

  ngAfterViewChecked() {
    console.log('search - ngAfterViewChecked');
  }

  async doInfinite(infiniteScroll) {
    console.log('[search] - doInfinite');

    await this.loadNext(true, infiniteScroll);

  }

  ngOnDestroy() {
    //console.log('search - ngOnDestroy');
    this.events.unsubscribe('search:textInput', this.searchTextInputSubs);
    this.events.unsubscribe('search:beerhiveInput', this.searchBeerhiveInputSubs);
    this.events.unsubscribe('search:colourInput', this.searchColourInputSubs);
    this.events.unsubscribe('search:textCancel', this.searchTextCancelSubs);
    this.events.unsubscribe("venue:deselected", this.venueDeselectedSubscription);
    this.events.unsubscribe("sortfilter:changed", this.sortfilterChangedSubscription);
    this.events.unsubscribe("venue:selected", this.venueSelectedSubscription);
    this.events.unsubscribe("clear:foundbeers", this.clearFoundBeersSubs);
    this.events.unsubscribe("remove:allsearch", this.removeAllSearchSubs);
    this.events.unsubscribe("search:addbeer", this.searchAddBeerSubscription);
    this.events.unsubscribe("navbar:searchpressed", this.searchButtonSubscription);
    //debugger;
  }

  updateAromasFromAnalysisMy(characteristics, alcoholIn, astringentIn, bodyIn, carbonationIn, intensityIn) {
    //debugger;
    this.log("[beer-analysis] updateAromasFromAnalysisMy()");
    let aromaCount = 0;

    for (let aroma of characteristics) {
      let underscoreIndex = aroma.indexOf("_");
      if (underscoreIndex != -1) {
        aromaCount++;
      }
      else {
        this.log("[beer-aromas] not adding aroma value " + aroma);
      }
    }

    /*
    if (aromaCount > 0/) {
      //this.log("[beer-analysis] PUB update:aromas updateAromasFromAnalysisMy()");
      //this.events.publish("update:aromas", characteristics);
      //TODO
    }
    else {

    }

    let alcohol = -1;
    let astringent = -1;
    let carbonation = -1;
    let intensity = -1;
    let body = -1;
    */

    // create an event
    let mouthfeelEvent = {};
    mouthfeelEvent["alcohol"] = alcoholIn;
    mouthfeelEvent["astringent"] = astringentIn;
    mouthfeelEvent["body"] = bodyIn;
    mouthfeelEvent["carbonation"] = carbonationIn;
    mouthfeelEvent["intensity"] = intensityIn;
    mouthfeelEvent["source"] = 2;

    // publish the event
    this.log("[beer-analysis] PUB update:mouthfeel 2");
    this.events.publish("update:mouthfeel", mouthfeelEvent);
    // catch the event in the beer-hive item (or add it to the update:aromas as an extra field)

  }

  // show the search params in a scrollable list, where the user can remove them again by clicking them
  updateSearchParams() {

    // debugger;//update search params!

    //loop through the list
    let critdiv = document.getElementById("cri");

    if (critdiv != null) {
      while (critdiv.firstChild) {
        critdiv.removeChild(critdiv.firstChild);
      }

      //add a remove all button
      let shouldAddTrash = false;
      if (this.allSearchCharacteristics.length > 0)
        shouldAddTrash = true;
      if (shouldAddTrash) {
        let iconpath = this.getIconPath("trash");

        let divelem = document.createElement("div");
        divelem.setAttribute("width", "60");

        let imgelem = document.createElement("img");
        imgelem.setAttribute("src", iconpath);
        imgelem.setAttribute("width", "30");
        imgelem.addEventListener('click', function (event) {
          this.removeAllSearchItems();
        }.bind(this), false);

        divelem.appendChild(imgelem);

        divelem.addEventListener('click', function (event) {
          this.removeAllSearchItems();
        }.bind(this), false);

        critdiv.appendChild(imgelem);
      }

      //debugger;
      let searchItems = this.searchProvider.getSearchParams();
      //let searchItems = this.allSearchCharacteristics;
      //this.searchProvider.setSearchParams(searchItems);
      //debugger;// update search params, add them all back
      // add the rest of the buttons (one button for each criterium)
      if (this.allSearchCharacteristics.length > 0) {
        for (let itemIndex in searchItems) {
          //debugger;
          let item = this.allSearchCharacteristics[itemIndex];
          let characteristic = item.characteristic;
          let charkey = characteristic.key;
          let iconpath = this.getIconPath(charkey);
          // get the icon
          // add a handler
          // add the icon to the div

          let divelem = document.createElement("div");
          divelem.setAttribute("width", "60");

          let imgelem = document.createElement("img");
          imgelem.setAttribute("src", iconpath);
          imgelem.setAttribute("width", "30");
          imgelem.addEventListener('click', function (event) {
            this.removeSearchItem(itemIndex);
          }.bind(this), false);

          /*let beforeNodes = critdiv.childNodes;
          critdiv.appendChild(elem);
          let afterNodes = critdiv.childNodes;*/

          let pelem = document.createElement("span");
          pelem.setAttribute("style", "vertical-align: top;");
          let textelem = document.createTextNode(" X ");
          pelem.appendChild(textelem);
          pelem.addEventListener('click', function (event) {
            this.removeSearchItem(itemIndex);
          }.bind(this), false);

          //xelem.setAttribute("width", "30");
          //xelem.setAttribute("text", "X");

          divelem.appendChild(imgelem);
          divelem.appendChild(pelem);

          divelem.addEventListener('click', function (event) {
            this.removeSearchItem(itemIndex);
          }.bind(this), false);

          //let beforeNodes = critdiv.childNodes;

          critdiv.appendChild(imgelem);
          critdiv.appendChild(pelem);

          //let afterNodes = critdiv.childNodes;

        }
      }
      else {
        //debugger;
        this.log("[SEARCH PARAMS] list of searchitems is empty!");
      }

    }
    else {
      this.log("critdiv is null...");
    }
  }

  deleteAll() {
    //debugger;
    this.log(" - delete all search items");

    //this.events.publish("remove:allsearch", true);

    let currentIndex = 0;
    for (let itemIndex in this.allSearchCharacteristics) {

      //debugger;// optie 2
      let itemToRemove = this.allSearchCharacteristics[itemIndex];
      let removeKey = itemToRemove.characteristic.key;
      if (removeKey === "colour") {
        // remove the color selection
        this.events.publish("remove:colour", true);
      }
      else if (removeKey === "sour" || removeKey === "bitter" || removeKey === "sweet" || removeKey === "hoppy" || removeKey === "fruity" || removeKey === "malty") {
        // reset the slider, this means that the slider value has to be set to value 0
        this.events.publish("reset:slider", removeKey);
      }
      else {
        // remove from the beerhive
        // this means that the status of the element has to change to "not selected"
        this.events.publish("remove:hive", removeKey);
      }
      currentIndex++;
    }

    //debugger;
    this.allSearchCharacteristics = [];
    this.searchProvider.resetSearchParams();

    // mag/moet deze ook weg?
    this.searchBeersCount();
  }

  removeAllSearchItems() {
    //debugger;
    this.log(" - remove all search items");

    this.events.publish("remove:allsearch", true);

    let currentIndex = 0;
    //let count = this.allSearchCharacteristics.length;
    for (let itemIndex in this.allSearchCharacteristics) {

      //debugger;// getting the key
      let itemToRemove = this.allSearchCharacteristics[itemIndex];
      let removeKey = itemToRemove.characteristic.key;
      if (removeKey === "colour") {
        //remove the color selection
        //debugger;// optie 1B
        this.events.publish("remove:colour", true);
      }
      else if (removeKey === "sour" || removeKey === "bitter" || removeKey === "sweet" || removeKey === "hoppy" || removeKey === "fruity" || removeKey === "malty") {
        //reset the slider, this means that the slider value has to be set to value 0
        this.events.publish("reset:slider", removeKey);
      }
      else {
        //remove from the beerhive
        //this means that the status of the element has to change to "not selected"
        this.events.publish("remove:hive", removeKey);
      }

      currentIndex++;
    }

    this.allSearchCharacteristics = []

    /*let index = 0;
    for(let item in this.allSearchCharacteristics){
      this.removeSearchItem(index);
      index++;
    }*/

    //this.updateSearchParams();

    this.searchBeersCount();
  }

  removeSearchItem(index: number) {
    this.log("remove search item at index " + index);

    //save
    let oldSearchCharacteristics = this.allSearchCharacteristics;
    //clear
    this.allSearchCharacteristics = [];

    //loop through the items
    let currentIndex = 0;
    //if currentIndex == index, remove
    for (let itemIndex in oldSearchCharacteristics) {
      if (currentIndex != index) {
        let theItem = oldSearchCharacteristics[itemIndex];
        //debugger;// adding 5
        this.allSearchCharacteristics.push(theItem);
        this.log("ADD 5 ADD" + theItem.characteristic.key);
        this.searchProvider.setSearchParams(this.allSearchCharacteristics);
      }
      else {
        //debugger;
        let itemToRemove = oldSearchCharacteristics[itemIndex];
        let removeKey = itemToRemove.characteristic.key;
        if (removeKey === "colour") {
          //remove the color selection
          //debugger;// optie 3
          this.events.publish("remove:colour", true);
        }
        else if (removeKey === "sour" || removeKey === "bitter" || removeKey === "sweet" || removeKey === "hoppy" || removeKey === "fruity" || removeKey === "malty") {
          //reset the slider, this means that the slider value has to be set to value 0
          this.events.publish("reset:slider", removeKey);
        }
        else {
          //remove from the beerhive
          //this means that the status of the element has to change to "not selected"
          this.events.publish("remove:hive", removeKey);
        }
      }
      currentIndex++;
    }
    //show again (update)
    // debugger; //update 2
    this.updateSearchParams();
    //debugger;
    //this.log(" calling searchBeersCount() from removeSearchItem");
    this.searchBeersCount();
  }

  //returns the path for a specific string
  getIconPath(key: String) {
    if (key === "trash") {
      let result = this.refdata.svgBaseUrl + "icon_delete_all.svg";
      return result;
    }
    else if (key === "colour") {
      let result = this.refdata.svgBaseUrl + "icon_sight_" + key + ".svg";
      return result;
    }
    else if (key === "sweet") {
      let result = this.refdata.svgBaseUrl + "icon_taste_" + key + ".svg";
      return result;
    }
    else if (key === "bitter") {
      let result = this.refdata.svgBaseUrl + "icon_taste_" + key + ".svg";
      return result;
    }
    else if (key === "sour") {
      let result = this.refdata.svgBaseUrl + "icon_taste_" + key + ".svg";
      return result;
    }
    else if (key === "body" || key === "intensity" || key === "carbonation" || key === "alcohol") {
      let result = this.refdata.svgBaseUrl + "icon_mouthfeel_" + key + ".svg";
      return result;
    }
    else if (key === "astringent") {
      let result = this.refdata.svgBaseUrl + "icon_mouthfeel_astringency.svg";
      return result;
    }
    else {
      if (key === "fruity_blackberry")
        key = "fruity_raspberry";
      if (key === "fruity_wildcherry")
        key = "fruity_cherry";
      if (key === "fruity_wild_cherry")
        key = "fruity_cherry";
      if (key === "fruity_green_apple")
        key = "fruity_apple";
      if (key === "fruity_red_apple")
        key = "fruity_apple";
      if (key === "fruity_greenapple")
        key = "fruity_apple";
      if (key === "fruity_redapple")
        key = "fruity_apple";
      if (key === "misc_medicinal")
        key = "misc_medicinal";

      let result = this.refdata.svgBaseUrl + "icon_aroma_" + key + ".svg";
      return result;
    }
  }

  searchBeersCount() {

    this.log("searchBeersCount called");

    /*let shouldNotCall = this.beerService.
    if(shouldNotCall) {
      return;
    }*/

    // debugger; // update 3
    this.updateSearchParams();

    this.userData.getUserID()
      .then((userID) => {
        this.log("(1 - user logged in:) " + userID);
        let user = new RequestUser(userID, this.locationService.latitude, this.locationService.longitude);

        let searchCharacteristics = [];
        for (let itemIndex in this.allSearchCharacteristics) {
          let item = this.allSearchCharacteristics[itemIndex];
          searchCharacteristics.push(item.characteristic);
        }
        if (this.allSearchCharacteristics.length == 0) {
          //no params give, no search count, instead show a message
          this.showInfoText = 'noSelection';
        }
        else {
          let searchRequest = new SearchRequest(user.userid, user.latitude, user.longitude, "", searchCharacteristics, this.rowCount, this.pageNumber, this.sortFilter.sortField, this.sortFilter.direction, (this.selectedVenue ? this.selectedVenue.id : null));
          this.log("calling getSearchCount with " + JSON.stringify(searchRequest));

          try {
            const respPromise: Promise<any> = firstValueFrom(this.beerService.getSearchCount(searchRequest));
            respPromise.then((resp) => {
              this.log("response for search request: " + JSON.stringify(resp));
              
              if (resp.count > 0) {
                this.showInfoText = 'beersFound';
                this.searchCount = resp.count;
              } else {
                this.showInfoText = 'noBeersFound';
                this.searchCount = resp.count;
              }
            }).catch(err => console.log(err));
          } catch(err) { console.log(err); }
        }
      });

/*
          this.beerService.getSearchCount(searchRequest).toPromise() // or firstValueFrom(...)
            .then((resp: any) => {
              this.log("response for search request: " + JSON.stringify(resp));
              
              if (resp.count > 0) {
                this.showInfoText = 'beersFound';
                this.searchCount = resp.count;
              } else {
                this.showInfoText = 'noBeersFound';
                this.searchCount = resp.count;
              }
            })
            .catch(err => {
              console.log(err);
            });
*/
/*
          this.beerService.getSearchCount(searchRequest).subscribe(
            (resp: any) => {
              this.log("response for search request: " + JSON.stringify(resp));
              if (resp.count > 0) {
                this.showInfoText = 'beersFound';
                this.searchCount = resp.count;
                //this.foundBeers = resp;
              }
              else {
                this.showInfoText = 'noBeersFound';
                this.searchCount = resp.count;
              }

            }, err => console.log(err));
*/
  }

  ionViewWillEnter() {
    if (this.refdata.isAndroid()) {
      console.log('setting fixed position dynamically for android');
      let critcontainerEl: HTMLElement = document.getElementById('critcontainer');
      critcontainerEl.style.position = 'fixed';
      // critcontainerEl.style.zIndex = '100';
    }
  }

  toggleCollapseColour() {
    this.collapseStateColour = (this.collapseStateColour == 'visible') ? 'invisible' : 'visible';
  }

  toggleCollapseTaste() {
    this.collapseStateTaste = (this.collapseStateTaste == 'visible') ? 'invisible' : 'visible';
  }

  toggleCollapseCharacteristics() {
    this.collapseStateCharacteristics = (this.collapseStateCharacteristics == 'visible') ? 'hidden' : 'visible';
    // let whitespaceEl: HTMLElement = document.getElementById('whitespace');
    // whitespaceEl.style.display = (this.collapseStateCharacteristics == 'visible' ? 'none' : 'block');
    let beerhiveContainerEl: HTMLElement = document.getElementById('beerhiveContainer');
    if (this.collapseStateCharacteristics == 'visible') {
//      beerhiveContainerEl.setAttribute("class", "beerhiveContainer_visible");
      beerhiveContainerEl.style.visibility = 'visible';
      beerhiveContainerEl.focus();
    }
    else {
      beerhiveContainerEl.setAttribute("class", "beerhiveContainer_hidden");
//      beerhiveContainerEl.style.visibility = 'hidden';
    }
  }
  /*
  setWhitespaceHeight() {
    try {
        let whitespaceEl: HTMLElement = document.getElementById('whitespace');
        whitespaceEl.style.height = '' + this.bhutil.hiveHeight() + 'px';
    } catch (error) {
      console.log('error setting whitespace height: ' + error);
    }
  }
  */

  updateFlavours(info: any) {
    this.log(" updateFlavours: now it is value " + info.value + " for type " + info.type);

    /*
    //let key = "colour";

    if (info.type === 'sweet') {
      //this.sweetValue = info.value;
    }
    else if (info.type === 'sour') {
      //this.sourValue = info.value;
    }
    else if (info.type === 'bitter') {
      //this.bitterValue = info.value;
    }
    else if (info.type === 'hoppy') {
      //this.hoppyValue = info.value;
    }
    else if (info.type === 'fruity') {
      //this.fruityValue = info.value;
    }
    else if (info.type === 'malty') {
      //this.maltyValue = info.value;
    }
    */

    let aromaCharacteristic: SearchCharacteristic = new SearchCharacteristic(info.type, info.value);
    let searchCharacteristicWithType: SearchCharacteristicWithType = new SearchCharacteristicWithType(SearchType.SEARCH_AROMA, aromaCharacteristic);
    let oldItems = this.allSearchCharacteristics;
    this.allSearchCharacteristics = [];
    let currentKey = info.type;

    // loop through all
    let itemIndex: any;
    for (itemIndex in oldItems) {
      //if type == SEARCH_HIVE, remove
      let item = oldItems[itemIndex];
      if (item.type != SearchType.SEARCH_AROMA && item.characteristic.value != -1) {//item.characteristic was info
        //debugger;
        // adding 6
        this.allSearchCharacteristics.push(item);
        this.log("ADD 6 ADD" + item.characteristic.key);
        this.searchProvider.setSearchParams(this.allSearchCharacteristics);
      }
      else {
        if (item.type == SearchType.SEARCH_AROMA) {
          let characteristic = item.characteristic;
          if (characteristic.key !== currentKey && item.characteristic.value != -1) {//item.characteristic was info
            //still add it
            //debugger;
            // adding 7
            this.allSearchCharacteristics.push(item);
            this.log("ADD 7 ADD" + item.characteristic.key);
            this.searchProvider.setSearchParams(this.allSearchCharacteristics);
          }
        }
      }
    }
    if (info.value != -1) {
      //debugger;
      // adding 8
      this.allSearchCharacteristics.push(searchCharacteristicWithType);
      this.log("ADD 8 ADD" + searchCharacteristicWithType.characteristic.key);
      this.searchProvider.setSearchParams(this.allSearchCharacteristics);
    }
    // perform the search count method
    //debugger;
    if (info.callServer) {
      this.log(" calling searchBeersCount() from updateFlavours");
      this.searchBeersCount();
    }
  }

  showBeers() {
    this.initFoundBeers();
    this.buildCharacteristicsSearchRequest();
    this.loadNext(false, null);
  }

  buildCharacteristicsSearchRequest() {
    let user = new RequestUser(this.userData.userID, this.locationService.latitude, this.locationService.longitude);

    let searchCharacteristics = [];
    for (let itemIndex in this.allSearchCharacteristics) {
      let item = this.allSearchCharacteristics[itemIndex];
      searchCharacteristics.push(item.characteristic);
    }

    this.searchRequest = new SearchRequest(user.userid, user.latitude, user.longitude, "", searchCharacteristics, this.rowCount, this.pageNumber, this.sortFilter.sortField, this.sortFilter.direction, (this.selectedVenue ? this.selectedVenue.id : null));
  }

  loadNext(isScroll: boolean, infiniteScroll: IonInfiniteScroll) {
    if (!this.fetchMore) {
      if (isScroll) {
        infiniteScroll.complete();
      }
      return;
    }
    if (!isScroll) {
      this.pageNumber = 0;

      this.isLoading.push(true);
      if (this.isLoading.length > 1) {
        this.executeLoadNext(isScroll, infiniteScroll);
      } else {
        this.loading = this.createLoading();
        this.loading.then(() => {
          this.executeLoadNext(isScroll, infiniteScroll);
        })
      }
    } else {
      this.executeLoadNext(isScroll, infiniteScroll);
    }
  }

  executeLoadNext(isScroll, infiniteScroll) {
    this.pageNumber++;
    this.searchRequest.pageNumber = this.pageNumber;
    this.searchRequest.sortField = this.sortFilter.sortField;
    this.searchRequest.direction = this.sortFilter.direction;
    this.searchRequest.venueId = (this.selectedVenue ? this.selectedVenue.id : null);

    this.beerService.search(this.searchRequest).subscribe(
      (resp: any) => {
        this.log("response for search request: " + JSON.stringify(resp));

        // this.foundBeers = resp;
        if (resp) {
          if (!isScroll) {
            this.foundBeers = [];
          }
          resp.forEach(element => {
            this.foundBeers.push(element);
          });
          if (resp.length == 0 || resp[resp.length - 1].hasMore == 0) {
            this.fetchMore = false;
          }
        }
        if (isScroll) {
          infiniteScroll.complete();
        } else {
          this.stopLoading();
        }
        this.showResults = true;
      },
      (err) => {
        console.log(err);
        if (isScroll) {
          infiniteScroll.complete();
        } else {
          this.stopLoading();
        }
      }
    );
  }

  createLoading() {
    return this.loadingCtrl.create({
      message: this.translateService.instant('GENERAL.PLEASE_WAIT')
    });
  }

  stopLoading() {
    this.isLoading.pop();
    if (this.isLoading.length == 0) {
      this.loadingCtrl.dismiss();
    }
  }

  ionViewWillLeave(): Promise<void> {
    this.log("ionViewCanLeave request");
    return new Promise((resolve, reject) => {
      if (this.backButtonPressed && this.showResults) {
        reject();
        this.events.publish("show:textsearchbar", true);
        this.showResults = false;
      } else {
        this.events.publish("show:textsearchbar", false);
        resolve();
      }
    });
  }
  private log(s: string): void {
    console.log("[search-page] " + s);
  }
}
